import fetcher from './fetchers'

/**
 * 用户类型
 */
export const UserTypes = Object.freeze({
  /** 普通用户 */
  NORMAL: 0,
  /** 元气 UP */
  UP: 1,
  /** 机器人 */
  ROBOT: 2,
  /** 元气大 UP */
  BIGUP: 3,
  /** 画师 */
  PAINTER: 4,
})

/**
 * 付费类型
 */
export const PTypes = Object.freeze({
  /** 免费壁纸 */
  FREE: 0,
  /** 付费壁纸 */
  VIP: 1,
  /** 广告壁纸 */
  AD: 2,
})

// http://apix.kisops.com/project/744/interface/api/39946
export const fetchCkey = async (ckey) => {
  const res = await fetcher.get('https://cdnpcwallpaper.zhhainiao.com/config/get/by/ckey', {
    params: {
      ckey,
    },
  })
  try {
    return JSON.parse(res.data)
  } catch (e) {
    return {}
  }
}

/** 证件类型 */
export const CertificateTypes = {
  /** 身份证 */
  IDCARD: 1,
  /** 港澳通行证 */
  GANGAO_PASSPORT: 2,
  /** 台湾通行证 */
  TAIWAN_PASSPORT: 3,
  /** 护照 */
  PASSPORT: 4,
}
